import extractApiData from 'Helpers/extractApiData'
import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'

const endpoints = (baseURL => {
  return {
    //  Generic
    exportEmailMessageList: (pageNum, pageSize) =>
      `${baseURL}/api/process/export/emailmessage/list?${encodeParams({
        pageNum,
        pageSize
      })}`,
    evaluateSendingBestPlanningTime: idList =>
      `${baseURL}/api/sending/lists/${encodeURIComponent(
        idList
      )}/bestplanningtime`
  }
})(process.env.BESTAT_URL)

export const beStatApiEvaluateSendingBestPlanningTime = (idList, data) => {
  const url = endpoints.evaluateSendingBestPlanningTime(idList)
  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify(data)
  }).then(extractApiData)
}

/**
 *
 * @param {int} pageNum
 * @param {int} pageSize
 * @param {Object} exportParams
 * @param {int} exportParams.IdList
 * @param {int[]} exportParams.IdMessages
 * @param {int[]} exportParams.IdTags
 * @param {string} exportParams.SearchText
 * @param {boolean} exportParams.SearchInBody
 * @param {string} exportParams.DateFrom
 * @param {string} exportParams.DateTo
 * @param {int[]} exportParams.MessageType
 * @param {int[]} exportParams.ServiceType
 * @param {boolean} exportParams.Archived
 * @param {boolean} exportParams.Published
 * @param {string} exportParams.OrderBy
 * @param {string} exportParams.ExportType
 */
export const beStatApiExportEmailMessageList = (
  pageNum,
  pageSize,
  exportParams
) => {
  const url = endpoints.exportEmailMessageList(pageNum, pageSize)

  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify(exportParams)
  }).then(extractApiData)
}
